// @flow
import React from "react";
import moment from "moment";
import type Moment from "moment";
import SelecaoValorBaseDeflator from "./SelecaoValorBaseDeflacao";
import SelecaoDataBaseDeflator from "./SelecaoDataBaseDeflacao";
import {
  type State,
  i18n,
  getPeriodoUnicoSelecionado,
  getValorBaseDeflatorOutroSelecionado,
  getValorBaseDeflatorSelecionado,
  getDataBaseDeflatorSelecionado,
  getDataBaseDeflatorEspecificaSelecionada,
} from "../../../../state";
import {
  type Id,
  ID_PERIODO_ANALISE_HORIZONTAL,
  ID_VALOR_BASE_DEFLATOR_OUTRO,
  ID_VALOR_BASE_DEFLATOR_NENHUM,
  ID_DATA_BASE_DEFLATOR_DATA_ESPECIFICA,
  ID_DATA_BASE_DEFLATOR_NENHUM,
} from "../../../../model";

type Props = {
  exibir?: boolean,
  forcarExibirNormalizacao?: boolean,
  exibirOpcaoNenhum?: boolean,
  utilizarEspacoTotal?: boolean,
};

const exibirSelecaoNormalizacao: (state: State) => boolean = (state: State) =>
  getPeriodoUnicoSelecionado(state) !== ID_PERIODO_ANALISE_HORIZONTAL;

function SelecaoNormalizacao({
  exibir = true,
  forcarExibirNormalizacao = false,
  exibirOpcaoNenhum = false,
  utilizarEspacoTotal = false,
}: Props) {
  if (!exibir) {
    return null;
  }

  return (
    <div className="ConfiguracaoMedida">
      <div
        className={
          utilizarEspacoTotal
            ? "ConfiguracaoMedida--flex-spaced"
            : "ConfiguracaoMedida--flex"
        }
      >
        <SelecaoValorBaseDeflator
          forcarExibirNormalizacao={forcarExibirNormalizacao}
          exibirOpcaoNenhum={exibirOpcaoNenhum}
        />
        <SelecaoDataBaseDeflator
          forcarExibirNormalizacao={forcarExibirNormalizacao}
          exibirOpcaoNenhum={exibirOpcaoNenhum}
        />
      </div>
    </div>
  );
}

export const criarFuncaoValidacaoSelecaoNormalizacao = (state: State) => () => {
  if (!exibirSelecaoNormalizacao(state)) {
    return null;
  }

  const { translate } = i18n(state);

  const valorBaseDeflatorSelecionado: ?Id =
    getValorBaseDeflatorSelecionado(state) ?? null;
  const valorBaseDeflatorOutro: ?number =
    getValorBaseDeflatorOutroSelecionado(state) ?? null;
  const dataBaseDeflatorSelecionada: ?Id =
    getDataBaseDeflatorSelecionado(state) ?? null;
  const dataEspecificaSelecionada: ?Moment =
    getDataBaseDeflatorEspecificaSelecionada(state) ?? null;

  const possuiValorBase =
    valorBaseDeflatorSelecionado !== null &&
    valorBaseDeflatorSelecionado !== ID_VALOR_BASE_DEFLATOR_NENHUM;
  const possuiDataBase =
    dataBaseDeflatorSelecionada !== null &&
    dataBaseDeflatorSelecionada !== ID_DATA_BASE_DEFLATOR_NENHUM;

  if (!possuiValorBase && possuiDataBase) {
    return {
      selecaoNormalizacao: translate(
        "configuracaoRelatorio.erroConfiguracaoNormalizacaoValorBaseObrigatorio"
      ),
    };
  } else if (possuiValorBase && !possuiDataBase) {
    return {
      selecaoNormalizacao: translate(
        "configuracaoRelatorio.erroConfiguracaoNormalizacaoDataBaseObrigatoria"
      ),
    };
  }

  if (valorBaseDeflatorSelecionado === ID_VALOR_BASE_DEFLATOR_OUTRO) {
    if (typeof valorBaseDeflatorOutro !== "number") {
      return {
        selecaoValorBaseDeflator: translate(
          "configuracaoRelatorio.valorBaseDeflatorInvalido"
        ),
      };
    }
  }

  if (dataBaseDeflatorSelecionada === ID_DATA_BASE_DEFLATOR_DATA_ESPECIFICA) {
    if (!moment.isMoment(dataEspecificaSelecionada)) {
      return {
        selecaoDataEspecifica: translate(
          "configuracaoRelatorio.erroDataEspecificaInvalida"
        ),
      };
    }
  }

  return null;
};

export default SelecaoNormalizacao;
